import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import {Navigate, useLocation} from 'react-router-dom';

import {selectAuth} from '../../redux/selectors';

const ProtectedRoute = ({children, allowedRoles}) => {
  const auth = useSelector(selectAuth);
  const location = useLocation();

  const loggedIn = auth.loggedIn;
  const user = auth.user;

  // 🔴 Not logged in → block immediately
  if (!loggedIn) {
    return (
      <Navigate
        to={'/'}
        replace
        state={{from: location}} // optional: for redirect back after login
      />
    );
  }

  // 🔴 Role not allowed
  if (allowedRoles && !allowedRoles.includes(user?.role)) {
    return <Navigate to={'/'} replace />;
  }

  // ✅ Allowed
  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  allowedRoles: PropTypes.array,
};

export default ProtectedRoute;
